export const MODULE_PATH_AUTH = 'authentication';

export const MODULE_PATH_AUTH_LOGIN = 'login';

export const MODULE_PATH_AUTH_REGISTER = 'register';

export const MODULE_PATH_AUTH_FORGOT_PASSWORD = 'forgot-password';